import React, { useEffect, useState } from 'react'
import hdfc from '@src/assets/images/manual/hdfc.png'
import { ButtonComp, ImgTag } from '../HtmlComp'
import { Button, Col, Row, Spinner } from 'reactstrap'
import './tricksDetails.scss'
import Modals from '../modal'
import { useLocation, useNavigate } from 'react-router-dom'

// ** images import

import img1 from '../../../assets/images/manual/1.png'
import img2 from '../../../assets/images/manual/2.png'
import img3 from '../../../assets/images/manual/3.png'
import img4 from '../../../assets/images/manual/4.png'
import img5 from '../../../assets/images/manual/18.png'
import img6 from '../../../assets/images/manual/19.png'
import img7 from '../../../assets/images/manual/7.png'
import img8 from '../../../assets/images/manual/8.png'
import img9 from '../../../assets/images/manual/9.png'
import img10 from '../../../assets/images/manual/10.png'
import img11 from '../../../assets/images/manual/11.png'
import { ArrowLeftCircle } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { myDateFormat } from '../../../utility/Utils'
import { getTrickDetail, setParamData, setSelect, setTrickDetailLoader } from './store'
import { setTrackParam, startTrick, stopTrick } from '../../pages/Home/store'

const TricksDetails = ({ parent }) => {
  const [showModal, setShowModal] = useState(false)
  const [type, setType] = useState('')
  const location = useLocation();
  const dispatch = useDispatch()
  let payload = {}
  const navigation = useNavigate()
  const headerDetails = useSelector((store)=>store?.home?.headerDetails)
  const { TrickDetail, error, trickDetailLoader, selected, status } = useSelector((store) => store?.TrickDetail)
  const toggle = (data) => {
    dispatch(setSelect(TrickDetail))
    setType(data)
    setShowModal(!showModal)
  }

  

  const handleMode = (data) => {
    toggle(data)
    if(headerDetails?.trade_subscription === 0 && data == 'LiveMode') {setType( 'TradeSubscription') }  // need to remove ! sign just keep for testing
    else{
      payload = {
        TricksId: TrickDetail?.TricksId,
        isTestModeActive: data === "TestMode" ? 1 : 0,
        Status: 1
      }
      dispatch(setTrackParam(payload))
    }
  }


  const handleStopTrick = (data) => {
    toggle(data)
    setType(data)
    payload = {
      TricksId: TrickDetail?.TricksId,
      Status: 0
    }
    dispatch(setTrackParam(payload))
  }

  const handleSellTrick = (data) => {
    toggle(data)
    setType(data)
    payload = {
      TricksId: TrickDetail?.TricksId,
      SellPositions: TrickDetail?.SellPositions,
    }
    dispatch(setTrackParam(payload))
  }

  const trackDetailsListSec3 = [
    // {
    //   imgUrl: img1,
    //   title: 'First Entry Buy Quantity',
    //   amount: (TrickDetail?.FirstEntryBuyQuantity !== null) ? TrickDetail?.FirstEntryBuyQuantity : '0',
    //   percent: false
    // },
    {
      imgUrl: img2,
      title: 'Buying - No of Level',
      amount: (TrickDetail?.BuyingNoOfLevel !== null) ? TrickDetail?.BuyingNoOfLevel : '0',
      percent: false
    },
    {
      imgUrl: img3,
      title: 'Take profit',
      amount: (TrickDetail?.TakeprofitPercent !== null) ? TrickDetail?.TakeprofitPercent : '0.00',
      percent: true
    },
    {
      imgUrl: img4,
      title: 'Sell profit price - bounce back from peak',
      amount: (TrickDetail?.SellProfitPriceBounceBackFromPeak !== null) ? TrickDetail?.SellProfitPriceBounceBackFromPeak : '0.00',
      percent: true
    },
    {
      imgUrl: img5,
      title: 'Buy price from low bounce back',
      amount: (TrickDetail?.BuyPriceFromLowBounceBack !== null) ? TrickDetail?.BuyPriceFromLowBounceBack : '0.00',
      percent: true
    },
    {
      imgUrl: img6,
      title: 'Sell price bounce back from peak for sub-position',
      amount: (TrickDetail?.SubPositionTakeProfitCallBack !== null) ? TrickDetail?.SubPositionTakeProfitCallBack : '0.00',
      percent: true
    },
    {
      imgUrl: img1,
      title: 'Trick Mode',
      amount: TrickDetail?.CycleMode === 1 ? 'Cycle' : 'One-Shot',
      percent: false
    },
  ]

  useEffect(() => {
    dispatch(setTrickDetailLoader(true))
    dispatch(getTrickDetail({ TrickId: location?.state }))
  }, [])

  useEffect(() => {
    dispatch(setParamData(TrickDetail))
  }, [trickDetailLoader])


  return (
    <>
  
      {trickDetailLoader ? <div className='TracksLoader'>
        <Spinner color='primary' />
      </div> : TrickDetail?.length === 0 ?
        <div className='TracksLoader'>
          <p className="text-center mb-0 w-100 text-dark">
            There are no Tricks to display
          </p>
        </div> : <div className="TricksDetails mt-1 px-2">
          <ArrowLeftCircle className='mb-2 backArrow' onClick={() => navigation(`/${location.pathname.split('/')[1]}`)} />
          {parent === 'my-tricks' && <h3 className='my-2 mx-1'>Make necessary changes to modify trick for</h3>}

          <Row>
            <Col md='6'>
              <p>Trick Amount Needed: <b>{TrickDetail?.trickAmountNeeded}</b></p>
            </Col>
            <Col md='6'>
              <p>Next Level Amount: <b>{TrickDetail?.nextLevelAmount}</b></p>
            </Col>
          </Row>

          <div className="sec1 d-flex justify-content-between">
            <div className="secCol1 d-flex">
              {TrickDetail?.Logourl && <ImgTag url={TrickDetail?.Logourl} alt={TrickDetail?.Symbol} title={TrickDetail?.Symbol} />}
              <p>{TrickDetail?.Symbol} :  <span className={TrickDetail?.Color==='R' ? 'red' : (TrickDetail?.Color==='G' ? 'green' : 'blue')  }> {TrickDetail?.Color==='R' && '-'} ₹{TrickDetail?.LTP}</span></p>
            </div>
            <div className="secCol2">
              <p>
                Trick ID:  {TrickDetail?.TricksId}</p>
              <p>Date : {TrickDetail?.CreatedOn && myDateFormat(TrickDetail?.CreatedOn)}</p>
            </div>
          </div>
          <Row className="sec2">
            <Col md='2' className='py-1'>
              <b>Position  Amount</b>
              <p>₹ {TrickDetail?.positionAmount || 0.00} </p>
            </Col>
            <Col md='2' className='py-1'>
              <b>Current  Amount</b>
              <p>₹ {TrickDetail?.currentPrice || 0.00}</p>
            </Col>
            <Col md='2' className='py-1'>
              <b>Average  Amount</b>
              <p>₹ {TrickDetail?.averagePrice || 0.00}</p>
            </Col>
            <Col md='2' className='py-1'>
              <b>Current No of Level</b>
              <p>{TrickDetail?.bynoofLevel || 0.00}</p>
            </Col>
            <Col md='2' className='py-1'>
              <b>Position Quantity</b>
              <p>{TrickDetail?.positionQTY || 0.00}</p>
            </Col>
            <Col md='2' className='py-1'>
              <b>Unrealised Gain/Loss</b>
              <p> {TrickDetail?.gainLoss || 0.00}</p>
            </Col>
          </Row>
          <div className="sec3">
            {
              trackDetailsListSec3.map(({ imgUrl, title, amount = 0, percent }) => <div className='grid-item'>
                <ImgTag url={imgUrl} />
                <b>{title}</b>
                <p>{amount} {percent ? `%` : ``}</p>
              </div>
              )
            }

          </div>
          {TrickDetail?.SL === 1 &&
          <div className={`Stop Loss`}>
                <ImgTag url={img2} />
                <h2>Stop Loss - 50%</h2>
           </div>
          }
          <div className="sec4 d-flex">
            {(TrickDetail?.SellPositions === 0 ) ? <div className='sellButton me-1' onClick={() => handleSellTrick('SellMyTrick')}>
              <ImgTag url={img9} />
              <p>Sell</p>
            </div> : ''}
            {(TrickDetail?.CycleMode !== null && TrickDetail?.Status === 1) ? <div className='Stoptricks ms-1' onClick={() => handleStopTrick('MyTricksStopTrick')}>
              <p>Stop Trick</p>
            </div> : ''}
          </div>

          
          {TrickDetail?.Status === 1 && <Row className="sec5">
            <Col xs='12' className='sec5Child d-flex justify-content-around'>
              <ButtonComp className="px-5 trade-setting-btn" name='Trick Setting' onClick={() => toggle('MyTricksTradeSettings')} />
            </Col>
            </Row>
          }
          
          {(TrickDetail?.CycleMode !== null) ?
            <div className='sec6 row justify-content-center'> 
              {(TrickDetail?.Status === 1) &&
              <>
              
              {(TrickDetail?.isTestModeActive !== 1) &&
                <div className='col-md-6'>
                  <div className={`grid-item ${(TrickDetail?.isTestModeActive && TrickDetail?.Status == 0) ? 'sec4Active' : ''}`} onClick={() => handleMode('TestMode')}>
                    <ImgTag url={img10} />
                    <h2>Start in Test Mode</h2>
                  </div>
                </div>
              }
              {(TrickDetail?.isTestModeActive !== 0) &&
                <div className='col-md-6'>
                  <div className={`grid-item ${(TrickDetail?.isTestModeActive && TrickDetail?.Status == 0) ? '' : 'sec4Active'}`} onClick={() => handleMode('LiveMode')}>
                    <ImgTag url={img11} />
                    <h2>Start in Live Mode</h2>
                  </div>
                </div>
              }
              </>
              }

              {/* {(TrickDetail?.Status === 1 && TrickDetail?.isTestModeActive === 1) &&
                <div className='col-md-6'>
                  <div className={`grid-item ${(TrickDetail?.isTestModeActive && TrickDetail?.Status == 0) ? '' : 'sec4Active'}`} onClick={() => handleMode('LiveMode')}>
                    <ImgTag url={img11} />
                    <h2>Start in Live Mode</h2>
                  </div>
                </div>
              } */}

            </div>
            : ''
          }
        </div>}
      <Modals toggle={toggle} payload={payload} showModal={showModal} type={type} setType={setType} />
    </>
  )
}

export default TricksDetails